import React, { useCallback, useEffect } from "react";
import { Helmet } from "react-helmet";
import '../designcss/tutorialcss.css';

//import AdScripts from "../components/ads";

const DownloadFiles15 = () => {
    const handleDownload = useCallback(() => {
        const files = [
            { href: 'https://gitlab.com/albiemerporte/myecommerceandportfolio2023/-/raw/v1/public/tutorial15/tutorial15.zip?ref_type=heads&inline=false', download: 'tutorial15.zip' }
        ];

        files.forEach(file => {
            const link = document.createElement('a');
            link.href = file.href;
            link.download = file.download;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        });
    }, []);

    return (
        <a href="#" onClick={handleDownload}>Download Repository</a>
    );
};

const TutorialFiftheen = () => {

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            {/* Add Adsterra script to head only on this page */}
            {/*<AdScripts />*/}

            <div className="blogcontainer" id="tutorial16">

                <div className="tutorial-banner" onClick={() => window.open("https://www.singlobby.com", "_blank")}>
                    <img src="https://res.cloudinary.com/dywqyzge2/image/upload/v1772299116/singlobby_banner_sokjnf.png" />
                </div>

                <div className="card">
                    <h2>How To Make Enable / Disable Textbox in Python3 With Qtdesigner GUI Load UI Tutorial</h2>

                    <div className="fakeimg" style={{ height: "auto", width: "90%" }}>
                        <img 
                            src="https://img.youtube.com/vi/vbyzcXew-ts/maxresdefault.jpg"
                            alt="Tutorial 15"
                            style={{ maxWidth: "100%", height: "auto" }}
                        />
                    </div>

                    <p style={{ whiteSpace: "pre-wrap" }}>
                    This tutorial demonstrates how to enable and disable a textbox (QLineEdit) in a PyQt6 application by connecting a button click event. Using a GUI created with Qt Designer, you'll learn how to load the .ui file into your Python script and control the input field dynamically.
                        <br /><strong>What you'll learn:</strong>
                        <ul>
                            <li>Loading .ui files using uic.loadUi</li>
                            <li>Connecting signals and slots</li>
                            <li>Programmatically toggling QLineEdit state</li>
                        </ul>
                        Perfect for building user-friendly desktop applications with conditional input controls.
                        <br /><br />
                        #Python #PyQt6 #QtDesigner #GUIDevelopment #Programming
                    </p>

                    <button className="seemore">
                        <DownloadFiles15 />
                    </button>
                </div>
            </div><br />
        </>
    );
};

export default TutorialFiftheen;
